import { render, staticRenderFns } from "./TeacherAssignmentDisplay.vue?vue&type=template&id=5e5689a3"
import script from "./TeacherAssignmentDisplay.vue?vue&type=script&lang=js"
export * from "./TeacherAssignmentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports